import request from '../request/request';

export const getFooterNavigations = () => {
  return request({
    url: `/webapi/platform-config/footer/navigations`,
    method: 'GET'
  });
};

export const getFooterPlatform = () => {
  return request({
    url: `/webapi/platform-config/footer/platform`,
    method: 'GET'
  });
};
